import React from "react";
import moment from "moment";
import {
  Box,
  Paper,
  styled,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[600],
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.selected,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export const ProcessDeadlines = ({ deadlines = [] }) => {
  const p = deadlines && deadlines.length > 0 ? deadlines[0] : {};

  const format = (d) => (d ? moment.utc(d).format("DD/MM/YYYY") : "---");

  return (
    <Paper sx={{ my: 1, p: 2 }}>
      <Typography mb={2} variant="h6">
        Prazos para prorrogação de registro de marca
      </Typography>
      <TableContainer component={Paper}>
        <Table size="small" sx={{ width: "100%" }}>
          <TableHead>
            <TableRow>
              <StyledTableCell></StyledTableCell>
              <StyledTableCell align="left">Prazo ordinário</StyledTableCell>
              <StyledTableCell align="left">Prazo extraordinário</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <StyledTableRow>
              <StyledTableCell>Início</StyledTableCell>
              <StyledTableCell>
                {format(p.data_inicio_prazo_ordinario)}
              </StyledTableCell>
              <StyledTableCell>
                {format(p.data_inicio_prazo_extraordinario)}
              </StyledTableCell>
            </StyledTableRow>
            <StyledTableRow>
              <StyledTableCell>Fim</StyledTableCell>
              <StyledTableCell>
                {format(p.data_fim_prazo_ordinario)}
              </StyledTableCell>
              <StyledTableCell>
                {format(p.data_fim_prazo_extraordinario)}
              </StyledTableCell>
            </StyledTableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};
